define.alias("checkout/components/interval", "settings/components/interval");